export const ColdLeadsMap = {
  GET_ALL_COLD_LEADS_START: "GET_ALL_COLD_LEADS_START",
  GET_ALL_COLD_LEADS_SUCCESS: "GET_ALL_COLD_LEADS_SUCCESS",
  GET_ALL_COLD_LEADS_ERROR: "GET_ALL_COLD_LEADS_ERROR",
  SEARCH_TEXT_CHANGE: "COLD_LEADS_SEARCH_TEXT_CHANGE",
  SET_COLD_LEADS_BATCH_NUMBER: "SET_COLD_LEADS_BATCH_NUMBER",
  GET_COLD_LEAD_START: "GET_COLD_LEAD_START",
  GET_COLD_LEAD_SUCCESS: "GET_COLD_LEAD_SUCCESS",
  GET_COLD_LEAD_ERROR: "GET_COLD_LEAD_ERROR",
  SET_AUDIO_TYPE: "COLD_LEADS_SET_AUDIO_TYPE",
  SET_BATCH_FILTER: "COLD_LEADS_SET_BATCH_FILTER",
  SET_DATE_FILTER: "COLD_LEADS_SET_DATE_FILTER",
  SET_FROM_DATE_FILTER: "COLD_LEADS_SET_FROM_DATE_FILTER",
  SET_TO_DATE_FILTER: "COLD_LEADS_SET_TO_DATE_FILTER",
  SET_LEAD_TYPE: "COLD_LEADS_SET_LEAD_TYPE",
  SET_CALL_OUTCOME_FILTER: "COLD_LEADS_SET_CALL_OUTCOME_FILTER",
  SET_CREATED_BY_FILTER: "COLD_LEADS_SET_CREATED_BY_FILTER",
  SET_LIMIT: "COLD_LEADS_SET_LIMIT",
  RESET_REFRESH_FLAG: "RESET_REFRESH_FLAG",
};

export const coldLeadsAction = {
  getAllColdLeadsStart: () => ({
    type: ColdLeadsMap.GET_ALL_COLD_LEADS_START,
  }),
  getAllColdLeadsSuccess: (payload) => ({
    type: ColdLeadsMap.GET_ALL_COLD_LEADS_SUCCESS,
    payload,
  }),
  getAllColdLeadsError: () => ({
    type: ColdLeadsMap.GET_ALL_COLD_LEADS_ERROR,
  }),
  searchTextChange: (text) => ({
    type: ColdLeadsMap.SEARCH_TEXT_CHANGE,
    payload: text,
  }),
  setColdLeadsBatchNumber: (batchNumber) => ({
    type: ColdLeadsMap.SET_COLD_LEADS_BATCH_NUMBER,
    payload: batchNumber,
  }),
  getColdLeadStart: () => ({
    type: ColdLeadsMap.GET_COLD_LEAD_START,
  }),
  getColdLeadSuccess: (payload) => ({
    type: ColdLeadsMap.GET_COLD_LEAD_SUCCESS,
    payload,
  }),
  getColdLeadError: () => ({
    type: ColdLeadsMap.GET_COLD_LEAD_ERROR,
  }),
  setAudioType: (audioType) => ({
    type: ColdLeadsMap.SET_AUDIO_TYPE,
    payload: audioType,
  }),
  setBatchFilter: (batchName) => ({
    type: ColdLeadsMap.SET_BATCH_FILTER,
    payload: batchName,
  }),
  setDateFilter: (date) => ({
    type: ColdLeadsMap.SET_DATE_FILTER,
    payload: date,
  }),
  setFromDateFilter: (date) => ({
    type: ColdLeadsMap.SET_FROM_DATE_FILTER,
    payload: date,
  }),
  setToDateFilter: (date) => ({
    type: ColdLeadsMap.SET_TO_DATE_FILTER,
    payload: date,
  }),
  setLeadType: (leadType) => ({
    type: ColdLeadsMap.SET_LEAD_TYPE,
    payload: leadType,
  }),
  setCallOutcomeFilter: (callOutcome) => ({
    type: ColdLeadsMap.SET_CALL_OUTCOME_FILTER,
    payload: callOutcome,
  }),
  setCreatedByFilter: (createdBy) => ({
    type: ColdLeadsMap.SET_CREATED_BY_FILTER,
    payload: createdBy,
  }),
  setLimit: (limit) => ({
    type: ColdLeadsMap.SET_LIMIT,
    payload: limit,
  }),
  resetRefreshFlag: () => ({
    type: ColdLeadsMap.RESET_REFRESH_FLAG,
  }),
};


